export default __webpack_public_path__ + "static/media/GustavDustParticleFrontLeft.0b2c8443.png";